import React from 'react'
import { TableSkeleton } from '@components/ui'
import './FormBuilderSkeleton.css'

const FormBuilderSkeleton: React.FC = () => (
  <div className="form-builder-skeleton" aria-hidden="true">
    <TableSkeleton rows={8} showPagination />
  </div>
)

export default FormBuilderSkeleton
